import React, { useEffect } from "react";
import "./Rotacare.css";
import Dashboard from "../images/Rota-Dashboard.png"

const Software = () => {
  return (
    <>
      <section>
        <main>
          <section className="RotaCare">
            <div className="container RotaCare-grid">
              <div>
                <span className="eyebrow">Built for care providers buy care providers</span>
                <h1>
                  Smarter rotas. Lower costs. <span>Better care.</span>
                </h1>
                <p className="RotaCare-copy">
                  Total Care Rota gives care homes and care providers one clear
                  system for staffing, attendance, compliance, payroll-ready
                  timesheets and workforce cost control.
                </p>

                <div className="RotaCare-actions">
                  <a href="#contact" className="btn btn-primary">
                    Book Your Free Demo
                  </a>
                  <a href="#features" className="btn btn-secondary">
                    Explore Features
                  </a>
                </div>

                <div className="trust-row">
                  <span className="trust-item">Care-sector focused</span>
                  <span className="trust-item">Fast implementation</span>
                  <span className="trust-item">Multi-site ready</span>
                </div>
              </div>

              <div className="product-frame">
                <div className="browser-bar">
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                </div>

                <div className="dashboard">
                  <img src={Dashboard} alt="" />
                </div>
              </div>
            </div>
             {/* Scroll Down */}
      <div className="scroll-down">
        <div className="mouse">
          <span></span>
        </div>

        <small>SCROLL DOWN</small>
      </div>
          </section>
          <div className="logo-strip">
            <div className="container logo-strip-inner">
              <p>Designed for the organisations delivering care every day</p>
              <span>Residential Care</span>
              <span>Nursing Care</span>
              <span>Homecare</span>
              <span>Supported Living</span>
            </div>
          </div>
          <div className="rota nav">
            <nav className="nav-rota" id="navLinks">
              <a href="#features">Features</a>
              <a href="#benefits">Benefits</a>
              <a href="#how-it-works">How It Works</a>
              <a href="#pricing">Pricing</a>
              <a href="#contact">Contact</a>
            </nav>
          </div>
          <section className="features" id="features">
            <div className="sec-heading">
              <span className="soft-title">Everything in one place</span>
              <h2>Control your workforce without the spreadsheets</h2>
              <p>
                Replace fragmented rota processes with a simple platform
                designed around the operational realities of social care.
              </p>
            </div>
            <div className="container-fluid">
              <div className="feature-grid">
                <article className="feature-card">
                  <div className="icon">R</div>
                  <h3>Drag-and-drop rotas</h3>
                  <p>
                    Create, copy and publish weekly rotas quickly across one or
                    multiple care services.
                  </p>
                </article>

                <article className="feature-card">
                  <div className="icon">£</div>
                  <h3>Live staffing costs</h3>
                  <p>
                    See salary, hourly, overtime and agency costs while the rota
                    is being built.
                  </p>
                </article>

                <article className="feature-card">
                  <div className="icon">✓</div>
                  <h3>Compliance alerts</h3>
                  <p>
                    Identify understaffing, excessive hours, expired records and
                    skills gaps before they create risk.
                  </p>
                </article>

                <article className="feature-card">
                  <div className="icon">T</div>
                  <h3>Time and attendance</h3>
                  <p>
                    Track clock-ins, lateness, absences and actual hours worked
                    from one dashboard.
                  </p>
                </article>

                <article className="feature-card">
                  <div className="icon">P</div>
                  <h3>Payroll-ready data</h3>
                  <p>
                    Approve timesheets and export accurate hours, enhancements
                    and deductions for payroll.
                  </p>
                </article>

                <article className="feature-card">
                  <div className="icon">A</div>
                  <h3>Agency management</h3>
                  <p>
                    Monitor agency usage, compare costs and reduce avoidable
                    temporary staffing spend.
                  </p>
                </article>
              </div>
            </div>
          </section>

          {/* <section className="benefits" id="benefits">
            <div className="container-fluid">
              <div className="visual-panel">
                <h3>Staffing cost visibility</h3>
                <p>
                  Compare planned hours, actual hours and agency spend across
                  the week.
                </p>

                <div className="chart">
                  <span className="bar"></span>
                  <span className="bar"></span>
                  <span className="bar"></span>
                  <span className="bar"></span>
                  <span className="bar"></span>
                  <span className="bar"></span>
                </div>

                <div className="chart-labels">
                  <span>Mon</span>
                  <span>Tue</span>
                  <span>Wed</span>
                  <span>Thu</span>
                  <span>Fri</span>
                  <span>Sat</span>
                </div>

                <div className="saving">
                  <div>
                    <span>Estimated monthly saving</span>
                    <strong>£4,280</strong>
                  </div>
                  <div>
                    <span>Agency reduction</span>
                    <strong>18%</strong>
                  </div>
                </div>
              </div>

              <div className="benefit-copy">
                <span className="eyebrow">Built around care operations</span>
                <h2>Make safer staffing decisions with better information</h2>
                <p>
                  Give managers, finance teams and senior leaders a real-time
                  view of workforce deployment, cost and compliance.
                </p>

                <div className="benefit-list">
                  <div className="benefit-item">
                    <div className="benefit-check">✓</div>
                    <div>
                      <h4>Reduce agency reliance</h4>
                      <p>
                        Spot uncovered shifts early and offer them to suitable
                        internal staff first.
                      </p>
                    </div>
                  </div>

                  <div className="benefit-item">
                    <div className="benefit-check">✓</div>
                    <div>
                      <h4>Protect staffing ratios</h4>
                      <p>
                        Maintain visibility of planned staffing levels, roles
                        and skills across every shift.
                      </p>
                    </div>
                  </div>

                  <div className="benefit-item">
                    <div className="benefit-check">✓</div>
                    <div>
                      <h4>Improve payroll accuracy</h4>
                      <p>
                        Reduce manual adjustments by approving actual attendance
                        before payroll is processed.
                      </p>
                    </div>
                  </div>

                  <div className="benefit-item">
                    <div className="benefit-check">✓</div>
                    <div>
                      <h4>Manage multiple locations</h4>
                      <p>
                        Review occupancy, staffing, hours and cost across your
                        entire group from one platform.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section> */}
          <section className="benefits" id="benefits">
            <div className="benefits-container">
              {/* LEFT CHART PANEL */}
              <div className="visual-panel">
                <h3>Staffing cost visibility</h3>

                <p>
                  Compare planned hours, actual hours and agency spend across
                  the week.
                </p>

                <div className="chart-wrapper">
                  <div className="chart">
                    {[
                      { day: "Mon", value: 55 },
                      { day: "Tue", value: 45 },
                      { day: "Wed", value: 75 },
                      { day: "Thu", value: 40 },
                      { day: "Fri", value: 60 },
                      { day: "Sat", value: 90 },
                    ].map((item) => (
                      <div className="bar-container" key={item.day}>
                        {/* Percentage shown on hover */}
                        <div className="bar-percentage">{item.value}%</div>

                        <span
                          className="bar"
                          style={{
                            height: `${item.value}%`,
                          }}
                        ></span>
                      </div>
                    ))}
                  </div>

                  <div className="chart-labels">
                    <span>Mon</span>
                    <span>Tue</span>
                    <span>Wed</span>
                    <span>Thu</span>
                    <span>Fri</span>
                    <span>Sat</span>
                  </div>
                </div>

                {/* SAVING BOX */}
                <div className="saving">
                  <div>
                    <span>Estimated monthly saving</span>
                    <strong>£4,280</strong>
                  </div>

                  <div>
                    <span>Agency reduction</span>
                    <strong>18%</strong>
                  </div>
                </div>
              </div>

              {/* RIGHT CONTENT */}
              <div className="benefit-copy">
                <span className="eyebrow">Built around care operations</span>

                <h2 className="benefit-heading">
                  Make safer staffing decisions with better information
                </h2>

                <p className="benefit-description">
                  Give managers, finance teams and senior leaders a real-time
                  view of workforce deployment, cost and compliance.
                </p>

                <div className="benefit-list">
                  <div className="benefit-item">
                    <div className="benefit-check">✓</div>

                    <div>
                      <h4>Reduce agency reliance</h4>
                      <p>
                        Spot uncovered shifts early and offer them to suitable
                        internal staff first.
                      </p>
                    </div>
                  </div>

                  <div className="benefit-item">
                    <div className="benefit-check">✓</div>

                    <div>
                      <h4>Protect staffing ratios</h4>
                      <p>
                        Maintain visibility of planned staffing levels, roles
                        and skills across every shift.
                      </p>
                    </div>
                  </div>

                  <div className="benefit-item">
                    <div className="benefit-check">✓</div>

                    <div>
                      <h4>Improve payroll accuracy</h4>
                      <p>
                        Reduce manual adjustments by approving actual attendance
                        before payroll is processed.
                      </p>
                    </div>
                  </div>

                  <div className="benefit-item">
                    <div className="benefit-check">✓</div>

                    <div>
                      <h4>Manage multiple locations</h4>
                      <p>
                        Review occupancy, staffing, hours and cost across your
                        entire group from one platform.
                      </p>
                    </div>
                  </div>

                  <div className="benefit-item">
                    <div className="benefit-check">✓</div>

                    <div>
                      <h4>Benefits</h4>
                      <p>
                        Take care of the repetitive stuff, so you can spend that
                        time where it actually matters - with your residents and
                        your team.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="how" id="how-it-works">
            <div className="container-fluid">
              <div className="sec-heading">
                <span>Simple implementation</span>
                <h2>From setup to live rota in four steps</h2>
                <p>
                  Our onboarding process is designed to get your managers
                  operational quickly.
                </p>
              </div>

              <div className="steps">
                <div className="step">
                  <h3>Set up your service</h3>
                  <p>
                    Add locations, departments, shift patterns, pay rules and
                    staffing requirements.
                  </p>
                </div>

                <div className="step">
                  <h3>Import your workforce</h3>
                  <p>
                    Upload employees, job roles, contracted hours, availability
                    and pay information.
                  </p>
                </div>

                <div className="step">
                  <h3>Build and publish</h3>
                  <p>
                    Create your rota, check cost and compliance, then publish
                    shifts to your team.
                  </p>
                </div>

                <div className="step">
                  <h3>Track and improve</h3>
                  <p>
                    Monitor attendance, agency use, staffing cost and payroll
                    data in real time.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="testimonial-section">
            <div className="container-fluid">
              <div className="sec-heading">
                <span>Trusted by care teams</span>
                <h2>Helping managers spend less time on rotas</h2>
                <p>
                  Illustrative testimonials can be replaced with verified
                  customer feedback before launch.
                </p>
              </div>

              <div className="testimonial-grid">
                <article className="testimonial">
                  <div className="stars">★★★★★</div>
                  <blockquote>
                    “We can now see the staffing cost before the rota is
                    published, which has made budgeting far more accurate.”
                  </blockquote>
                  <div className="author">
                    <div className="avatar">RM</div>
                    <div>
                      <strong>Registered Manager</strong>
                      <span>Residential care provider</span>
                    </div>
                  </div>
                </article>

                <article className="testimonial">
                  <div className="stars">★★★★★</div>
                  <blockquote>
                    “Copying rotas, filling shifts and approving hours is much
                    faster. Our managers have better control across every home.”
                  </blockquote>
                  <div className="author">
                    <div className="avatar">OD</div>
                    <div>
                      <strong>Operations Director</strong>
                      <span>Multi-site care group</span>
                    </div>
                  </div>
                </article>

                <article className="testimonial">
                  <div className="stars">★★★★★</div>
                  <blockquote>
                    “The agency and overtime visibility has helped us make
                    better decisions and challenge unnecessary spend.”
                  </blockquote>
                  <div className="author">
                    <div className="avatar">FD</div>
                    <div>
                      <strong>Finance Director</strong>
                      <span>Nursing care operator</span>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </section>

          <section className="transp-pricing" id="pricing">
            <div className="container-fluid">
              <div className="transp-pricing-card">
                <div>
                  <span>Transparent pricing</span>
                  <h2>
                    Powerful rota software without enterprise-level complexity
                  </h2>
                  <p>
                    Start with the core rota platform and scale across
                    additional services as your organisation grows. Contact us
                    for onboarding, integrations and group pricing.
                  </p>
                </div>

                <div className="price-box">
                  <small>From</small>
                  <strong>£2</strong>
                  <span>per employee, per month</span>
                </div>
              </div>
            </div>
          </section>

          <section className="cta" id="contact">
            <div className="container-fluid">
              <div className="cta-wrap">
                <h2>
                  See how Total Care Rota could work for your organisation
                </h2>
                <p>
                  Book a personalised demonstration and see how to simplify rota
                  management, control staffing costs and improve workforce
                  oversight.
                </p>

                <div className="cta-actions">
                  <a
                    href="mailto:info@totalcareadvisory.com?subject=Total%20Care%20Rota%20Demo"
                    className="btn btn-primary"
                  >
                    Book a Demo
                  </a>
                  <a href="tel:+440000000000" className="btn btn-secondary">
                    Speak to Our Team
                  </a>
                </div>
              </div>
            </div>
          </section>
        </main>
      </section>
    </>
  );
};

export default Software;
